import React, { useRef, useState } from "react";
import "./Css/Invoice.css";
import { useNavigate } from "react-router-dom";

const Invoice = () => {
        const navigate = useNavigate();
        const [showPopup, setShowPopup] = useState(false);

  const printRef = useRef();

  const handlePrint = () => {
    window.print();
  };
 const handleDownload = () => {
    // here you can trigger actual download logic if needed
    setShowPopup(true);

    // auto close popup after 3 seconds
    setTimeout(() => {
      setShowPopup(false);
    }, 3000);
  };
  return (
    <div className="invoice-page">
       <div className="page-header">
        <h3    style={{ cursor: "pointer" }}
        onClick={() => navigate(-1)}>
         पेमेंट प्रक्रिया &gt;&gt; <span>पावती</span>
        </h3>
        <div className="invoice-actions">
          <button className="btn-outline" onClick={handlePrint}>
          प्रिंट इनव्हॉईस
        </button>
  <button className="btn-primary" onClick={handleDownload}>
        डाउनलोड
      </button>
            </div>
      </div>

      {/* Invoice */}
      <div className="invoice-container" ref={printRef}>
        <h2 className="school-name">अजना विद्यालय, पाटण</h2>
        <p className="school-address">पत्ता : नागरी रोड</p>
        <p className="gst">GST नंबर : <strong>३३६६८८९९९९९ </strong></p>

        <hr />

        <div className="invoice-meta">
          <div>
            <strong>कमिशन (५%)</strong>
          </div>
          <div>
            <strong>ट्रान्झाक्शन आयडी: TXN-१०२५-८५६३

              <br/>
महिना: जानेवारी २०२६</strong>
          </div>
           </div>
        <hr />

        {/* Table */}
        <table className="invoice-table">
          <thead>
            <tr>
              <th>पुस्तकाचे नाव </th>
              <th>नग</th>
              <th>किंमत</th>
              <th>रक्कम</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>सराव प्रश्नपत्रिका संच क्रमांक तीन </td>
              <td>१२</td>
              <td>१००</td>
              <td>१२००</td>
            </tr>
            <tr>
              <td>माझी सुलेखन पुस्तिका</td>
               <td>१२</td>
              <td>१००</td>
              <td>१२००</td>
            </tr>
            <tr>
              <td>भाषा परीक्षण ५०० उतारे</td>
              <td>१०</td>
              <td>१००</td>
              <td>२०००</td>
            </tr>
          </tbody>
        </table>

        {/* Summary */}
        <div className="summary">
          <div className="summary-row">
            <span>एकूण</span>
            <span>४४००</span>
          </div>
          <div className="summary-row">
            <span>कमिशन (५%)</span>
            <span>५% | २२०</span>
          </div>
          <div className="summary-row">
            <span>संपूर्ण रक्कम</span>
            <span>२२०.००</span>
          </div>
        </div>

        <p className="note">
         अथर्व कुणाल प्रकाशन  
          <br />
          Please use INV-00001 as a further reference number<br/>
          काही प्रश्न असल्यास, कृपया आमच्याशी संपर्क साधा akesbooks@gmail.com
        </p>
      </div>
       {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <p>तुमची पावती यशस्वीपणे डाउनलोड झाली आहे.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Invoice;
